// extracted by mini-css-extract-plugin
module.exports = {"documentCard":"_2TBGr","documentText":"_287C6","startNowCta":"_1MgdL"};